var map = {
	"./ab.png": 4713,
	"./ad.png": 6232,
	"./ae.png": 6981,
	"./af.png": 3528,
	"./ag.png": 3872,
	"./ai.png": 9806,
	"./al.png": 5373,
	"./am.png": 9453,
	"./an.png": 9166,
	"./ao.png": 9866,
	"./aq.png": 5438,
	"./ar.png": 2525,
	"./as.png": 8407,
	"./at.png": 1652,
	"./au.png": 8925,
	"./aw.png": 9675,
	"./ax.png": 1832,
	"./az.png": 8618,
	"./ba.png": 1019,
	"./bb.png": 8217,
	"./bd.png": 218,
	"./be.png": 4472,
	"./bf.png": 6187,
	"./bg.png": 2213,
	"./bh.png": 3831,
	"./bi.png": 534,
	"./bj.png": 5026,
	"./bl.png": 2489,
	"./bm.png": 687,
	"./bn.png": 614,
	"./bo.png": 4012,
	"./bq.png": 6269,
	"./br.png": 6053,
	"./bs.png": 9558,
	"./bt.png": 9542,
	"./bw.png": 6295,
	"./by.png": 125,
	"./bz.png": 4437,
	"./ca.png": 7354,
	"./cc.png": 8965,
	"./cd.png": 6546,
	"./cf.png": 7577,
	"./cg.png": 5304,
	"./ch.png": 9980,
	"./ci.png": 4406,
	"./ck.png": 8535,
	"./cl.png": 2113,
	"./cm.png": 7178,
	"./cn.png": 5722,
	"./co.png": 6906,
	"./cr.png": 3211,
	"./cu.png": 6851,
	"./cv.png": 1061,
	"./cw.png": 6253,
	"./cx.png": 4782,
	"./cy.png": 3567,
	"./cz.png": 9370,
	"./de.png": 3199,
	"./dj.png": 4704,
	"./dk.png": 836,
	"./dm.png": 5767,
	"./do.png": 9773,
	"./dz.png": 4961,
	"./ec.png": 4744,
	"./ee.png": 7624,
	"./eg.png": 9654,
	"./eh.png": 1793,
	"./empty.png": 9234,
	"./er.png": 486,
	"./es.png": 964,
	"./et.png": 9109,
	"./fi.png": 3082,
	"./fj.png": 9632,
	"./fk.png": 1485,
	"./fm.png": 7868,
	"./fo.png": 9093,
	"./fr.png": 2012,
	"./ga.png": 1753,
	"./gb.png": 4112,
	"./gd.png": 1602,
	"./ge.png": 9125,
	"./gf.png": 6816,
	"./gg.png": 2684,
	"./gh.png": 9000,
	"./gi.png": 3393,
	"./gl.png": 2844,
	"./gm.png": 9649,
	"./gn.png": 3101,
	"./gp.png": 3356,
	"./gq.png": 3086,
	"./gr.png": 1579,
	"./gt.png": 5679,
	"./gu.png": 6901,
	"./gw.png": 8658,
	"./gy.png": 5956,
	"./hk.png": 5008,
	"./hn.png": 4266,
	"./hr.png": 4577,
	"./ht.png": 3173,
	"./hu.png": 6072,
	"./id.png": 2849,
	"./ie.png": 206,
	"./il.png": 4397,
	"./im.png": 1257,
	"./in.png": 3213,
	"./io.png": 7987,
	"./iq.png": 7978,
	"./ir.png": 5899,
	"./is.png": 1290,
	"./it.png": 4233,
	"./je.png": 7883,
	"./jm.png": 222,
	"./jo.png": 2661,
	"./jp.png": 4498,
	"./ke.png": 609,
	"./kg.png": 7603,
	"./kh.png": 9875,
	"./ki.png": 4031,
	"./km.png": 2572,
	"./kn.png": 9890,
	"./kp.png": 9808,
	"./kr.png": 9807,
	"./kw.png": 4943,
	"./ky.png": 3915,
	"./kz.png": 3251,
	"./la.png": 9466,
	"./lb.png": 9539,
	"./lc.png": 6647,
	"./li.png": 4626,
	"./lk.png": 9338,
	"./lr.png": 6892,
	"./ls.png": 2906,
	"./lt.png": 2174,
	"./lu.png": 1507,
	"./lv.png": 6173,
	"./ly.png": 5220,
	"./ma.png": 4935,
	"./mc.png": 2061,
	"./md.png": 5342,
	"./me.png": 6515,
	"./mf.png": 4687,
	"./mg.png": 6497,
	"./mh.png": 6408,
	"./mk.png": 2703,
	"./ml.png": 5282,
	"./mm.png": 7096,
	"./mn.png": 2689,
	"./mo.png": 3763,
	"./mp.png": 8020,
	"./mq.png": 2561,
	"./mr.png": 4433,
	"./ms.png": 4002,
	"./mt.png": 2520,
	"./mu.png": 9222,
	"./mv.png": 5504,
	"./mw.png": 9171,
	"./mx.png": 2528,
	"./my.png": 9913,
	"./mz.png": 6704,
	"./na.png": 311,
	"./nc.png": 729,
	"./ne.png": 6756,
	"./nf.png": 5541,
	"./ng.png": 8123,
	"./ni.png": 9075,
	"./nl.png": 5952,
	"./no.png": 7701,
	"./np.png": 6951,
	"./nr.png": 5969,
	"./nu.png": 2017,
	"./nz.png": 5526,
	"./om.png": 817,
	"./os.png": 5893,
	"./other/_ASEAN.png": 9858,
	"./other/_African Union(OAS).png": 1279,
	"./other/_Arab League.png": 6991,
	"./other/_CARICOM.png": 4617,
	"./other/_CIS.png": 5453,
	"./other/_Commonwealth.png": 1059,
	"./other/_England.png": 9353,
	"./other/_European Union.png": 4718,
	"./other/_Islamic Conference.png": 5609,
	"./other/_Kosovo.png": 3188,
	"./other/_NATO.png": 4604,
	"./other/_Northern Cyprus.png": 2839,
	"./other/_Northern Ireland.png": 4201,
	"./other/_OPEC.png": 2382,
	"./other/_Olimpic Movement.png": 1493,
	"./other/_Red Cross.png": 9450,
	"./other/_Scotland.png": 9289,
	"./other/_Somaliland.png": 4640,
	"./other/_United Nations.png": 7628,
	"./other/_Wales.png": 2465,
	"./pa.png": 5072,
	"./pe.png": 7339,
	"./pf.png": 8842,
	"./pg.png": 4,
	"./ph.png": 4911,
	"./pk.png": 8,
	"./pl.png": 2410,
	"./pm.png": 2449,
	"./pn.png": 9513,
	"./pr.png": 6175,
	"./ps.png": 8418,
	"./pt.png": 354,
	"./pw.png": 6902,
	"./py.png": 5936,
	"./qa.png": 9161,
	"./re.png": 7026,
	"./ro.png": 3845,
	"./rs.png": 1997,
	"./ru.png": 2890,
	"./rw.png": 845,
	"./sa.png": 7888,
	"./sb.png": 8617,
	"./sc.png": 3684,
	"./sd.png": 3967,
	"./se.png": 9115,
	"./sg.png": 1512,
	"./sh.png": 4191,
	"./si.png": 270,
	"./sk.png": 7906,
	"./sl.png": 1986,
	"./sm.png": 9936,
	"./sn.png": 6178,
	"./so.png": 4607,
	"./sr.png": 5197,
	"./ss.png": 7688,
	"./st.png": 9689,
	"./sv.png": 3877,
	"./sx.png": 4832,
	"./sy.png": 9775,
	"./sz.png": 7179,
	"./tc.png": 848,
	"./td.png": 3705,
	"./tg.png": 6778,
	"./th.png": 9784,
	"./tj.png": 9334,
	"./tk.png": 3927,
	"./tl.png": 2714,
	"./tm.png": 6766,
	"./tn.png": 4189,
	"./to.png": 6715,
	"./tr.png": 7213,
	"./tt.png": 7175,
	"./tv.png": 621,
	"./tw.png": 7345,
	"./tz.png": 1335,
	"./ua.png": 7410,
	"./ug.png": 2423,
	"./um.png": 7690,
	"./us.png": 2642,
	"./uy.png": 3418,
	"./uz.png": 3190,
	"./va.png": 7205,
	"./vc.png": 3005,
	"./ve.png": 1705,
	"./vg.png": 4877,
	"./vi.png": 6061,
	"./vn.png": 6260,
	"./vu.png": 6114,
	"./wf.png": 6259,
	"./ws.png": 7059,
	"./ye.png": 6891,
	"./yt.png": 7799,
	"./za.png": 4058,
	"./zm.png": 8858,
	"./zw.png": 4337
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3367;